import { render, staticRenderFns } from "./asignarProyectos.vue?vue&type=template&id=6a5bc2a7"
import script from "./asignarProyectos.vue?vue&type=script&lang=js"
export * from "./asignarProyectos.vue?vue&type=script&lang=js"
import style0 from "./asignarProyectos.vue?vue&type=style&index=0&id=6a5bc2a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports